<template>
  <div>
    <CCard>
      <CCardBody>
        <div class="row" style="padding-bottom: 10px">
          <div class="col-4">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Search"
              style="border-radius: 3rem"
            ></b-form-input>
          </div>
          <div class="col-8">
            <CButton
              block
              color="danger"
              @click="addservice"
              style="width: fit-content; height: fit-content; float: right"
              >Add Service</CButton
            >
          </div>
        </div>

        <b-table
          class="myTable"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          show-empty
          sort-icon-right
          responsive="sm"
        >
          <template v-slot:cell(foto)="data">
            <img v-if="data.item.photoUrl" :src="data.item.photoUrl" style="width: 100px; height: 60px;padding:5px 5px" />
             <img v-else
            src="../../assets/No.png"
      class="img-fluid"
                    alt="..."
                    style="width: 74px; height:60px;padding:5px 5px"
                  />
          </template>
          <template #cell(show_details)="item">
            <td style="none">
              <CButton
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="toggleDetails(item)"
                >View</CButton
              >
            </td>
          </template>
        </b-table>
        <div class="mat-table__bottom">
          <span style="margin-right: 20px; margin-bottom: 15px">
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </span>
          <span class="">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
            ></b-pagination>
          </span>
        </div>
        
         </CCardBody
    ></CCard>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/jszip.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/xlsx.js"></script>
<script>
import firebase from "firebase";

export default {
  components: {
  },
  data: () => {
    return {
            filter: "",
      bimg: null,
      datavalue: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [ 5, 10, 15],

      fields: [
        {
          key: "foto",
          label: "Services",
          sortable: false,
          editable: true,
          image: true,
          tbClass: "bTableThStyle",
        },

        { key: "name", label: "Name", sortable: true, sortDirection: "desc" ,class: "text-center",
},
        {
          key: "provide",
          label: "Treat for",
          sortable: true,
          class: "text-center",
        },
        {
          key: "service",
          label: "Treated by",
          sortable: true,
          class: "text-center",
        },
        {
          key: "show_details",
          label: "Action",
        },
      ],
      id: "",
      datavalue: "",
      items: [],
    };
  },
  methods: {
    toggleDetails(items) {
      console.log(items.item, "Editing Item");
      this.$router.push({
        name: "editservice",
        params: {
          id: items.item.userid,
          data: items.item,
        },
      });
    },
    addservice() {
      var app = this;
      app.$router.push("/addservice");
    },

    getservicelist() {
      const db = firebase.firestore();
      db.collection("service")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.id = doc.id;

            this.datavalue = {
              userid: doc.id,
              photoUrl: doc.data().photoUrl,
              Id: doc.data().id,
              service: doc.data()["treated by"],
              des: doc.data().des,
              name: doc.data().name,
              provide: doc.data().provide,
            };
            this.items.push(this.datavalue);
                              this.totalRows =this.items.length
            console.log(this.items, "doctors");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    // this.getcatalogList()
    // this.getcategoryList()
  },
  created: function () {
    this.getservicelist();
    console.log("Created");
  },
};
</script>
<style >
.myTable thead {
  font-weight: 600;
  font-family: "Montserrat";
  font-size: 18px;
  color: #3b4859;
}
.custom-select-sm {
  font-family: "Montserrat";
}
.myTable td {
  color: #3b4859;
  font-family: "Assistant";
  font-weight: 500;
  font-size: 14px;
}
.mat-table__bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.b-pagination-pills .page-item .page-link {
  color: #3b4859;
  border: transparent;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 400;
}
.page-item.active .page-link {
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 400;
  background: #ff0000;
  color: #fff;
  border: #ff0000;
}
.table td{
  padding: 0;
    vertical-align:0;
    border-top: none;
    border-top-color: none;
}
</style>
